// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CustomSidebar from "../../../../pricing-dashboard/view/components/library/reuseable-components/CustomSidebar.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Column$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as TemplateListCmp from "./TemplateListCmp.bs.js";
import * as CreateTemplateCmp from "./create-template/CreateTemplateCmp.bs.js";
import * as SelectTemplateCmp from "../send-sms/SelectTemplateCmp.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as SendSmsDataMachine from "../../../app/repo/SendSmsDataMachine.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var searchIcon = SendSMSAssetsManager.getImage("search.svg");

function TemplateManagerCmp(Props) {
  var openSnackbar = Props.openSnackbar;
  var show_sidepanel = Props.show_sidepanel;
  var set_show_sidepanel = Props.set_show_sidepanel;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setTemplateList = match$1[1];
  var templateList = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setSearchValue = match$2[1];
  var searchValue = match$2[0];
  var fetchSmsTemplateList = function (param) {
    return SendSmsDataMachine.fetchSmsTemplateList(country, (function (data) {
                  return Curry._1(setTemplateList, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  Curry._1(setTemplateList, (function (param) {
                          return {
                                  TAG: /* Error */2,
                                  _0: error
                                };
                        }));
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                            });
                }));
  };
  var handleApiResponse = function (data, functionality) {
    var match = data.status_code;
    if (match !== 200) {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                });
    } else {
      Curry._1(openSnackbar, {
            TAG: /* Success */0,
            _0: "Request to " + functionality + " SMS Template has been completed"
          });
      Curry._1(set_show_sidepanel, false);
      return fetchSmsTemplateList(undefined);
    }
  };
  var onDeleteClick = function (template_id) {
    return SendSmsDataMachine.deleteSmsTemplate({
                template_id: template_id
              }, country, (function (data) {
                  return handleApiResponse(data, "Delete");
                }), (function (error) {
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                }));
  };
  var onCreateTemplateClick = function (message_title, message_body, toggleLoader) {
    return SendSmsDataMachine.createSmsTemplate({
                message_title: message_title,
                message_body: message_body
              }, country, (function (data) {
                  Curry._1(toggleLoader, (function (param) {
                          return false;
                        }));
                  return handleApiResponse(data, "Create");
                }), (function (error) {
                  Curry._1(toggleLoader, (function (param) {
                          return false;
                        }));
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                }));
  };
  React.useEffect((function () {
          Curry._1(setTemplateList, (function (param) {
                  return {
                          TAG: /* Loading */0,
                          _0: undefined
                        };
                }));
          fetchSmsTemplateList(undefined);
          
        }), []);
  var filteredTemplates = SelectTemplateCmp.FilterTemplates.filteredTemplates(templateList, searchValue);
  var tmp;
  if (typeof templateList === "number") {
    tmp = null;
  } else {
    switch (templateList.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(TemplateListCmp.make, {
                    template_list: filteredTemplates,
                    row_function: onDeleteClick
                  }), React.createElement(CustomSidebar.make, {
                    is_open: show_sidepanel,
                    on_back_drop_click: (function (param) {
                        return Curry._1(set_show_sidepanel, false);
                      }),
                    children: React.createElement(CreateTemplateCmp.make, {
                          set_show_sidepanel: set_show_sidepanel,
                          create_function: onCreateTemplateClick
                        })
                  }));
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: templateList._0
              });
          break;
      
    }
  }
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-template-manager"
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: "left-section"
                }, React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._1(setSearchValue, (function (param) {
                                            return FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                          }));
                            }), undefined, undefined, "Search via Template ID or Title", undefined, undefined, undefined, undefined, undefined, "search-input", undefined, undefined, {
                            className: "",
                            startAdornment: React.createElement("div", {
                                  className: "search-image"
                                }, React.createElement("img", {
                                      src: searchIcon
                                    })),
                            accept: undefined
                          }, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: searchValue
                      }
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Create New Template"
                          }, false, (function (_event) {
                              return Curry._1(set_show_sidepanel, true);
                            }), undefined, undefined, undefined, undefined, "create-template-btn", undefined, undefined)
                    })), tmp);
}

var make = TemplateManagerCmp;

export {
  searchIcon ,
  make ,
  
}
/* searchIcon Not a pure module */
